export default "__VITE_ASSET__DWofggKt__"